(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('.ca-pr-summary-tabs__tab');
    var panels = root.querySelectorAll('.ca-pr-summary-tabs__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('aria-controls');
        if (!targetId) return;

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ca-pr-summary-tabs').forEach(initTabs);
  });
})();
